import { EMPLOYEE_PROFILE_PATH } from "@/modules/profile/pages/employee-profile";
import { generatePath, Navigate } from "react-router-dom";

export function OpenPerson() {
  const url = new URL(window.location.href);

  return (
    <Navigate
      to={generatePath(EMPLOYEE_PROFILE_PATH, {
        id: url.searchParams.get("id"),
      })}
    />
  );
}
